module.exports = __webpack_public_path__ + "static/img/card-guides_on.8a7bbfce.png";